export default function formatPriceToInternational(amount) {
  const formattedPrice = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2, useGrouping: false });
  return formattedPrice.format(amount);;
}